/**
 * Created by elad on 15 נובמבר 2016.
 */
import VueRouter from "vue-router";
import middleware from "./middleware";
import UsersView from "./view/users/UsersView";
import CompaniesView from "./view/companies/CompaniesView";
import GamesView from "./view/games/GamesView";
import GameLogsView from "./view/gamelogs/GameLogsView";
import Dashboard from "./Dashboard";
import GameQuestionView from "./view/gameQuestions/GameQuestionView";
import PlayView from "./view/play/PlayView";
import TypesView from "./view/types/TypesView";
import TypesCircles from "./view/types/TypesCircles";
import UpdatesView from "./view/updates/UpdatesView";
import OrganizationsView from "./view/organizations/OrganizationsView";
import PublicUserForm from "./view/users/PublicUserForm";
import CreateGame from "./view/games/CreateGame";
import PlansView from "./view/plans/PlansView";
import LoginClapwayView from "./view/auth/LoginClapwayView";
import GameDisplayView from "./view/games/GameView";
import CenterManageView from "./view/center/CenterManageView";

const routes = [
  { path: "/", redirect: { name: "games-page", query: { init: 1 } }, name: "root-page" },
  { path: "/login", component: LoginClapwayView, name: "login-page" },
  { path: "/game/:id", component: PlayView, name: "play-page" },
  {
    path: "/game/edit/:id",
    name: "game-display-view",
    component: GameDisplayView,
    meta: { RequireAuth: true }
  },
  { path: "/game/share/:id", component: PlayView, name: "share-play-page" },
  {
    path: "/dashboard",
    component: Dashboard,
    children: [
      { path: "/register", component: PublicUserForm, name: "register" },
      {
        path: "/types",
        component: TypesCircles,
        name: "types-circles",
        meta: { RequireAuth: true, subscription: true }
      },
      {
        path: "/type",
        component: TypesView,
        name: "game-type-page",
        meta: { RequireAuth: true, role: 1 }
      },
      {
        path: "/organizations",
        component: OrganizationsView,
        name: "organization-page",
        meta: { RequireAuth: true, role: 1 }
      },
      {
        path: "/users",
        component: UsersView,
        name: "users-page",
        meta: { RequireAuth: true, role: 1 }
      },
      {
        path: "/companies",
        component: CompaniesView,
        name: "companies-page",
        meta: { RequireAuth: true, role: 1 }
      },
      {
        path: "/games",
        component: GamesView,
        name: "games-page",
        meta: { RequireAuth: true, subscription: true }
      },
      {
        path: "/center",
        component: CenterManageView,
        name: "center-manage",
        meta: { RequireAuth: true, subscription: true,role: 4 }
      },
      {
        path: "/games/form/",
        component: CreateGame,
        name: "game-form-create",
        meta: { RequireAuth: true, subscription: true }
      },
      {
        path: "/games/form/:id",
        component: CreateGame,
        name: "game-form",
        meta: { RequireAuth: true }
      },
      {
        path: "/game/edit/:id",
        component: GameQuestionView,
        name: "game-question",
        meta: { RequireAuth: true }
      },
      {
        path: "/game-logs",
        component: GameLogsView,
        name: "game-log-page",
        meta: { RequireAuth: true }
      },
      {
        path: "/updates",
        component: UpdatesView,
        name: "updates-page",
        meta: { RequireAuth: true }
      },
      {
        path: "/plans",
        component: PlansView,
        name: "plans-page",
        meta: { RequireAuth: true, footer: true }
      }
    ]
  }
];

const router = new VueRouter({
  history: false,
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  middleware.check(to, from, next);
});

export default router;
